import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import { EggNumber } from './EggNumber';
import ReactSound from 'react-sound';
import { useSelector } from 'react-redux';

import eggBrokenSound from '../sounds/play-egg-broken.mp3';
import AnimationWithSound from '../AnimationWithSound';

export const PLAYER_EGG = {
  NOT_DISPLAYED: 0,
  NORMAL: 1,
  BROKEN: 2,
};

const PlayerEgg = ({ amount, state }) => {
  const { images } = useImagesContext();
  const config = useSelector((state) => state.config);
  const [ownState, setOwnState] = React.useState([state]);

  React.useEffect(() => {
    if (state === PLAYER_EGG.BROKEN) {
      setOwnState((v) => [...v, state]);
      setTimeout(() => {
        setOwnState([state]);
      }, 500);
    } else {
      setOwnState([state]);
    }
  }, [state]);

  return (
    <>
      {ownState.includes(PLAYER_EGG.NORMAL) && (
        <Block $background={images['play-egg-player.png']}>
          <EggNumber
            number={amount}
            top="55px"
            fontHeight="84px"
            filePrefix="play-egg-player-"
          />
        </Block>
      )}
      {ownState.includes(PLAYER_EGG.BROKEN) && (
        <AnimationWithSound
          imageUrl={images['play-player-egg-broken.png']}
          imageTop={831}
          imageLeft={3}
          imageWidth={240}
          imageHeight={245}
          soundFile={eggBrokenSound}
          playSound={!config.isMutedSound}
        />
      )}
    </>
  );
};

const Block = styled.div`
  position: absolute;
  top: 850px;
  left: 20px;
  width: 159px;
  height: 177px;
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-repeat: no-repeat;
`;

const PlayerEggBroken = styled.img`
  position: absolute;
  top: 830px;
  left: 5px;
  width: 240px;
  height: 245px;
`;

export default PlayerEgg;
